import React from "react";

export const EDGE = "clamp(20px, 6vw, 120px)";
export const MAXW = 1440;

export function Section({ id, bg, children, style = {}, pt = 130, pb = 130 }) {
  return (
    <section
      id={id}
      style={{
        background: bg,
        paddingLeft: EDGE,
        paddingRight: EDGE,
        paddingTop: pt,
        paddingBottom: pb,
        position: "relative",
        ...style,
      }}
    >
      <div style={{ maxWidth: MAXW, margin: "0 auto", width: "100%", position: "relative" }}>
        {children}
      </div>
    </section>
  );
}

export function Button({
  href = "#",
  variant = "solid",
  children,
  arrow = false,
  big = false,
  style = {},
  onClick,
}) {
  const pad = big ? "0 26px" : "0 20px";
  const h = big ? 54 : 46;
  const fs = big ? 16 : 15;
  return (
    <a
      href={href}
      onClick={onClick}
      className={`btn btn--${variant}`}
      style={{ height: h, padding: pad, fontSize: fs, borderRadius: 8, ...style }}
    >
      {children}
      {arrow && (
        <span className="arw" aria-hidden="true" style={{ fontSize: fs + 1 }}>
          {"\u2192"}
        </span>
      )}
    </a>
  );
}

export function Kicker({ children, style = {} }) {
  return (
    <span
      style={{
        fontFamily: 'Georgia, "Times New Roman", serif',
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        color: "var(--green)",
        ...style,
      }}
    >
      {children}
    </span>
  );
}

const STATUS = {
  Live: { c: "#7a5210", bg: "#f4ead2" },
  "Early access": { c: "var(--green)", bg: "var(--green-tint)" },
  Next: { c: "#3f4a53", bg: "rgba(20,32,27,0.07)" },
  Later: { c: "var(--muted)", bg: "rgba(20,32,27,0.05)" },
  "In research": { c: "var(--muted)", bg: "rgba(20,32,27,0.05)" },
};

export function StatusTag({ status, style = {} }) {
  const s = STATUS[status] || STATUS.Later;
  return (
    <span
      style={{
        fontFamily: '"IBM Plex Mono", monospace',
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: "0.04em",
        padding: "4px 9px",
        borderRadius: 999,
        color: s.c,
        background: s.bg,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {status}
    </span>
  );
}

// window chrome dots
export function Dots() {
  return (
    <span style={{ display: "inline-flex", gap: 7 }}>
      {["#e0655a", "#e6b04a", "#5bb173"].map((c, i) => (
        <span
          key={i}
          style={{ width: 11, height: 11, borderRadius: "50%", background: c, opacity: 0.85 }}
        />
      ))}
    </span>
  );
}
